
import {tap} from 'rxjs/operators';
import { Observable } from 'rxjs';

import {AfterViewChecked, AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';

import { JuridictionCodeEnum, TypeJuridiction } from '../../../entities/type-juridiction';
import { ScrollToService } from '../../../shared';
import { ErrorService } from '../../../shared/services/error.service';
import { DepotRequeteState } from '../../depot-requete-state.model';
import { DraftDepotRequeteService } from '../../draft-depot-requete.service';

@Component({
    templateUrl: './juridiction.component.html',
    styleUrls: ['./juridiction.component.scss']
})
export class JuridictionComponent implements AfterViewChecked, OnInit, AfterViewInit {
    depotRequeteState: DepotRequeteState;

    private scrollTarget: string;
    private scrollToError = false;
    public requerantAutoSaveSuccess = false;
    public autoSaveError = false;
    public saveDraftSuccess = false;
    public saveDraftError = false;
    private autoSaveTime: any;

    @Output() previousStep: EventEmitter<any> = new EventEmitter();
    @Output() nextStep: EventEmitter<any> = new EventEmitter();
    @Output() hideAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showErrorAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showSuccessAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showAutoSaveSuccessAlertDraft: EventEmitter<any> = new EventEmitter();

    @ViewChild(NgForm) form: NgForm;

    constructor(
        private scrollToService: ScrollToService,
        private errorService: ErrorService,
        private draftDepotRequeteService: DraftDepotRequeteService,
    ) {
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepRequerantAutoSaveSucceed && !this.depotRequeteState.isStepJuridictionAutoSaveSucceed) {
            this.requerantAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
    }

    ngOnInit(): void {
        this.hideAlertDraft.emit();
        if (this.requerantAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    }

    ngAfterViewInit() {
      document.getElementById('logo-link').focus();
    }

    ngAfterViewChecked(): void {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    }

    next(): Observable<void> {
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            return this.saveJuridiction().pipe(tap(
                () => {
                    this.depotRequeteState.isStepJuridictionAutoSaveSucceed = true;
                    this.nextStep.emit()
                },
                error => {
                    this.autoSaveError = true;
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                }
            ));
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    }

    saveDraft(): Observable<void> {
        this.hideAlertDraft.emit();

        return this.saveJuridiction().pipe(tap(
            () => {
                this.saveDraftSuccess = true;
                this.requerantAutoSaveSuccess = false;
                this.showSuccessAlertDraft.emit();
            },
            error => {
                this.saveDraftError = true;
                this.requerantAutoSaveSuccess = false;
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        ));
    }

    saveJuridiction(): Observable<any> {
        return this.draftDepotRequeteService.saveJuridiction();
    }

    saveDraftAgain(): any {
        this.saveJuridiction().subscribe(
            () => {
                this.saveDraftSuccess = true;
                this.requerantAutoSaveSuccess = false;
                this.showSuccessAlertDraft.emit();
            },
            error => {
                this.saveDraftError = true;
                this.requerantAutoSaveSuccess = false;
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        );
    }

    close() {
        this.autoSaveError = false;
    }

    previous(): void {
        this.depotRequeteState.isStepJuridictionAutoSaveSucceed = false;
        this.previousStep.emit();
    }

    onTypeJuridictionChange(typeJuridiction: TypeJuridiction) {
        this.resetFields();
        if (typeJuridiction.code === JuridictionCodeEnum.CE) {
            this.depotRequeteState.siteJuridiction = typeJuridiction.siteJuridictions[0];
            this.scrollTarget = '.jhi-juridiction-section';
        } else {
            this.scrollTarget = '.jhi-juridiction-section';
        }
    }

    resetFields(): void {
        this.depotRequeteState.siteJuridiction = undefined;
        this.resetField('site-juridiction');
        this.depotRequeteState.urgenceRequete = undefined;
        /* this.resetField('urgence-requete'); */
        this.depotRequeteState.typeActeAttaque = undefined;
        this.resetField('type-acte-attaque');
    }

    displaySiteJuridictionSection(): boolean {
        return (
            this.depotRequeteState.typeJuridiction &&
            this.depotRequeteState.typeJuridiction.code !== JuridictionCodeEnum.CE
        );
    }

    displayTypeActeAttaqueSection(): boolean {
        return Boolean(
            this.depotRequeteState.typeJuridiction &&
                this.depotRequeteState.typeJuridiction.code === JuridictionCodeEnum.CAA &&
                this.depotRequeteState.siteJuridiction
        );
    }

    private resetField(fieldName: string): void {
        let field = this.form.controls[fieldName];
        if (field) {
            field.markAsUntouched();
            field.markAsPristine();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/juridiction.component.ts